// extracted by mini-css-extract-plugin
module.exports = {"controls":"controls_controls__HrQfq"};